import { z } from 'zod';

/** The guided tours the frontend runs, each once per account: the projects
 *  page on first visit, a project's page on the first one opened, the chat on
 *  the first conversation. */
export const TOUR_IDS = ['projects', 'project', 'chat'] as const;
export type TourId = (typeof TOUR_IDS)[number];

export const CompletedToursSchema = z.object({
  completed: z.array(z.enum(TOUR_IDS)),
});
export type CompletedTours = z.infer<typeof CompletedToursSchema>;
